export const getElevation = (raisedProp, variantProp) => {
    if (raisedProp) {
        return 5;
    }
    else if (variantProp === 'outlined') {
        return 0;
    }
    return 1;
};
